<div class="buttonwrapper">
  <button
    mat-button
    [color]="'accent'"
    (click)="addTimestamp()"
  >
    Zeitstempel einfügen
  </button>
</div>

<app-internal-note-form
  [selectedElement]="selectedCart().obj"
  [displayHeaders]="false"
  [standardForm]="true"
  (formChange)="onFormChange($event)"
  (instanceInitialized)="onInstanceInitialized($event)"
/>

